/**
 * Created by why on 2019/10/21.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const getMessageByCondition = (data) => {
  return axios.request({
    url: '/message/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getById = (id) => {
  return axios.request({
    url: `/message/getById/${id}`,
    method: 'get'
  })
}

export const messageSave = (data) => {
  return axios.request({
    url: '/message/save',
    data: data,
    method: 'post'
  })
}

export const messageEdit = (data) => {
  return axios.request({
    url: '/message/edit',
    data: data,
    method: 'post'
  })
}

export const messageDelByIds = (ids) => {
  return axios.request({
    url: `/message/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/message-manage.js